/**
 * Admin Button Access Management Logic
 */
export function initButtonAccess() {
    // Select2 is now handled globally in app.js

    const formButton = $('#formButton');
    const storeUrl = formButton.data('store-url') || (window.location.origin + '/button-access/store');

    // Show empty Modal
    $('[data-bs-target="#modalAddButton"]').on('click', function() {
        formButton[0].reset();
        formButton.attr('action', storeUrl);
        $('#modalButtonTitle').text('Add Button Access Setting');
        // Reset all permission checkboxes
        $('.permission-check').prop('checked', false);
        // Reset Select2
        $('#menu_id').val('').trigger('change');
        $('#modalButton').modal('show');
    });

    // Edit Modal
    $(document).on('click', '.btn-edit-button', function() {
        const btnData = $(this).data('button');
        const baseUrl = storeUrl.replace('/store', '');
        
        formButton.attr('action', `${baseUrl}/${btnData.id}/update`);
        $('#modalButtonTitle').text('Edit Button Access');
        
        $('#menu_id').val(btnData.menu_id).trigger('change');
        $('#button_name').val(btnData.button_name);
        $('#button_identifier').val(btnData.button_identifier);
        
        // Set permission checkboxes
        $('.permission-check').prop('checked', false);
        if (btnData.permission) {
            const perms = btnData.permission.split(',').map(p => p.trim());
            perms.forEach(function(p) {
                $('#perm_' + p).prop('checked', true);
            });
        }
        
        $('#modalButton').modal('show');
    });

    // NOTE: Delete is handled by global-crud.js via .btn-delete-submit

}
